import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=1c8e0e95&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=1c8e0e95&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e0e95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8e0e95')) {
      api.createRecord('1c8e0e95', component.options)
    } else {
      api.reload('1c8e0e95', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=1c8e0e95&scoped=true", function () {
      api.rerender('1c8e0e95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_4/HeaderMenu.vue"
export default component.exports